import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ChatLayer from "../components/ChatLayer";


const Chat = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Social Chat" />

        {/* ChatLayer */}
        <ChatLayer />


      </MasterLayout>
    </>
  );
};

export default Chat;
